import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { eHierarchyLevel } from "../../../../functions/api/enums";
import { ParentTemplateLink } from "../ParentTemplateLink";
import { RenderReleaseStatus } from "../RenderReleaseStatus";
import { TlfItemTableFlags } from "../TlfItemTableFlags";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";
import { TlfItemTableTagsCell } from "../TlfItemTableTagsCell";
import { TlfItemTaVersionsLinks } from "../TlfItemTaVersionsLinks";
import { filterTemplates } from "./filterTemplates";
import { searchTemplatesWithText } from "./searchTemplatesWithText";

/** Hierarchy levels that show the parent template column. */
const parentTemplateLevels: eHierarchyLevel[] = [eHierarchyLevel.TA, eHierarchyLevel.Project];

/** Hierarchy levels that show the versions available column. */
const versionsLevels: eHierarchyLevel[] = [eHierarchyLevel.Corporate];

/**
 * Returns the template table headers for a hierarchy level, including only the columns
 * relevant at that level.
 *
 * @param hierarchyLevel - Current hierarchy level, used to control column visibility and labels
 * @returns Template headers filtered and labelled for the given hierarchy level
 */
export const templateHeaders = (hierarchyLevel: eHierarchyLevel): ISimpleTableField[] => [
  {
    name: "azsolIdVersion",
    label: "AZSOL ID/Version",
    width: "110px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
    searchFn: searchTemplatesWithText,
    filterOutFn: filterTemplates,
    renderFn: TlfItemTableLinkCell,
  },
  {
    name: "tlfTagValues",
    label: "Tags",
    width: "200px",
    canColumnFilter: true,
    renderFn: TlfItemTableTagsCell,
  },
  { name: "flags", label: "", width: "50px", renderFn: TlfItemTableFlags },
  {
    name: "domain",
    label: "Domain",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  ...(parentTemplateLevels.includes(hierarchyLevel)
    ? [
        {
          name: "parentTemplate",
          label: "Parent Template",
          width: "100px",
          canColumnFilter: true,
          renderFn: ParentTemplateLink,
          sortFn: simpleTableSortFn,
        },
      ]
    : []),
  ...(versionsLevels.includes(hierarchyLevel)
    ? [
        {
          name: "taVersionsAvailable",
          label: "TA Versions Available",
          width: "200px",
          canColumnFilter: true,
          renderFn: TlfItemTaVersionsLinks,
        },
      ]
    : []),
  {
    name: "tocLabel",
    label: "Title",
    width: "550px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "type",
    label: "Type",
    width: "80px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "releaseStatus",
    label: "Status",
    width: "80px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
    renderFn: RenderReleaseStatus,
  },
  {
    name: "releaseDate",
    label: "Release date",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "decommissionDate",
    label: "Decommission date",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "additionalInformation",
    label: "Additional information",
    width: "150px",
    canColumnFilter: true,
  },
];
